import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
//import { Observable } from 'rxjs/Observable';
// tslint:disable-next-line:import-blacklist
//import 'rxjs/Rx';
//throwError
import { Observable,pipe } from 'rxjs';
import { tap, catchError, finalize, map } from 'rxjs/operators'
import { AuthTokenService } from './authToken.service';
import { HttpStatusNotifierService } from '../http-status-notifier.service';
import { Router } from '@angular/router';
import { AuthUserService } from './authUser.service';
import { LocalStorage } from '@ngx-pwa/local-storage';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private tokenPromise: Observable<any>;
  constructor(private authtokenService: AuthTokenService,
              private userService : AuthUserService,
              private httpStatusNotifier: HttpStatusNotifierService,
              private localStorage: LocalStorage) {
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    request = request.clone({
      withCredentials: true,
      setHeaders: {
        Authorization: `Bearer ${this.authtokenService.AuthToken.access_token}`
      }
    });

    this.httpStatusNotifier.setHttpStatus(true);

    return next.handle(request).do((event: HttpEvent<any>) => {
        return event;
      },
      (err: any) => {
        if (err.status === 401) {
          // Handle unauthorized http code
          this.unauthorizedHandler();
        }

        this.httpStatusNotifier.setHttpStatus(false);
      }, () => {
          this.httpStatusNotifier.setHttpStatus(false);
      });
  }

  private async unauthorizedHandler() {
    // Unauthorized http code
    // Clear token & user from local storage & services
    // Add display message in local storage
    // Force page reload to log-in as Anonymous user
    
    await this.localStorage.clear().toPromise();
    await this.localStorage.setItem('UserNotification', "Session expired, User logged out")
                           .toPromise();
    this.authtokenService.AuthToken = null;
    this.userService.AuthUser = null;
    window.location.reload();
  }

}



// WEBPACK FOOTER //
// ./src/app/services/appInitialization/token.Interceptor.ts